import React, { Component } from 'react';
import Wrp from '../../../hoc/Wrp/Wrp';
// import BootstrapColumn from '../../../hoc/BootstrapColumn';
import FormInput from '../../../Components/FormInputFields';
import debounce from 'lodash.debounce';

class SearchRecord extends Component {
    constructor(props) {
        super(props);
        this.state = {
          searchValue: this.props.search,
          typing: false,
          typingTimeout: 0
        }
        // this.debouncedFetchResults = debounce(this.debouncedFetchResultsHandler, 100);
      }
      componentDidUpdate = (prevProps,prevState) =>{
        if(prevProps.search!==this.props.search&&prevState.searchValue!==this.state.searchValue){
            this.setState({searchValue:this.props.search});
        }
    } 
    
    debouncedFetchResultsHandler = (pagination,bool)=>{
        // console.log('pagination,bool',pagination,bool);
        this.props.onSearhRecord(); 
        this.props.recordsChangeHandler(pagination,bool);
    }
    searchOnChangeHandler= (value) =>{
        let getVal = value;
        
         
        const pagination = {
            ...this.props,
            page:0,
            search:encodeURIComponent(getVal)
        }
        
        this.setState({searchValue:encodeURIComponent(getVal)});
        this.debouncedFetchResultsHandler(pagination,(this.props.isOnSearhRecord===true)?false:true)
        // this.debouncedFetchResults(pagination,(this.props.isOnSearhRecord===true)?false:true);

        // const self = this;
        // const selfProps = this.props;
        // if (self.state.typingTimeout) {
        //     clearTimeout(self.state.typingTimeout);
        // }
        // self.setState({
        //     searchValue: encodeURIComponent(getVal),
        //     typing: false,
        //     typingTimeout: setTimeout(function () {
        //         selfProps.onSearhRecord();
        //         selfProps.recordsChangeHandler(pagination,true);
        //         }, 800)
        // });
    }
    // componentWillUnmount() {
    //     this.debouncedFetchResults.cancel();
    //   }

    render () {
        let getVal = this.state.searchValue;
        // console.log('isOnSearhRecord',this.props.isOnSearhRecord);
        //getVal = getVal.replace('%25','%');
        const item = {
            type:'TextInput',
            value:decodeURIComponent(getVal),
            className:'form-control form-control-sm',
            attributes:{
              name:'search',
              id:'search',
              "aria-controls":"add-row",
              onKeyDown: (e) => {
                if (e.keyCode  === 13) {
                  e.preventDefault(); // Prevent the default "Enter" behavior (e.g., form submission)
                //   console.log('Enter key pressed');
                  this.searchOnChangeHandler(e.target.value); // Call the search handler with the current value
                }
              },
            //   onBlur:(e)=>this.searchOnChangeHandler(e.target.value),
              placeholder: "Search"
            },
            changeHandler:(val)=>{this.setState({searchValue:encodeURIComponent(val)})}
        }
        // console.log('decodeURIComponent(this.props.search)',this.props.gridView);
        return (
            this.props.gridView && (this.props.gridView === "splitWindow" || this.props.gridView === "logs" ) ?
                <FormInput {...item}/>
            : 
            <Wrp>
                <div id=""  className="dataTables_filter">
                    
                    <div className="d-sm-block d-none">
                        <FormInput {...item}/>
                    </div>

                    <div className="nav-item tableSearch_MiniView search-dropdown d-sm-none pt-1">
                        <a data-toggle="dropdown" className="cursor-pointer pr-2 dropdown-toggle hidden-caret"aria-expanded="false">
                            <i className="fa fa-search secondary_color fa-lg"></i>
                        </a>
                        <a className="pr-2 cursor-pointer d-none">
                            <i className="fas fa-times primary_color fa-lg"></i>
                        </a>
                        <div className="dropdown-menu">
                            <div>
                                <div className="input-group search-box">                                
                                    <FormInput {...item}/>
                                    <div className="input-group-append">
                                        <a className="btn border-default btn-border" id="closeSearch"> 
                                            <i className="fas fa-times fa-lg"></i> 
                                        </a>
                                    </div>                                     
                                </div>                       
                            </div>
                        </div>
                    </div>
                </div>
            </Wrp>
        )
    }
}
SearchRecord.defaultProps = {
    onSearhRecord:()=>{},
    isOnSearhRecord:false,
}

export default SearchRecord;